import React, { } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon
    ,MDBModal,MDBModalBody , MDBModalHeader } from 'mdbreact';


    



const InfoBox=(props)=> {


    return (
        <MDBContainer>
              <MDBModal
              
              backdrop={false}
              isOpen={props.isOpen}
              toggle={props.toggleModal}
              fullHeight
              position="right"
          >
              <MDBModalHeader
              className="text-left black-text cloudy-knoxville-gradient"
              titleClass="w-100"
              tag="h5"
            
              >
              
                 
                    
              </MDBModalHeader>
              <MDBModalBody className="text-center">
                  <MDBRow>
                  <MDBCol
                        size="3"
                        className="text-center"
                        >
                        {/* <MDBIcon icon="exclamation-triangle" size="5x" className="orange-text" />  */}
                        <MDBIcon icon="check-circle" size="5x" className="blue-text" /> 
                        </MDBCol>
                        <MDBCol size="9" className="black-text text-center">
                        <p> 
                        
                        </p>
                        <p>
                           
                            {props.errorMessage}
                          
                        </p>
                        <p className="text-center">
                                <MDBBtn className="cloudy-knoxville-gradient black-text" onClick={props.toggleModal}>
                                Got it
                            </MDBBtn>
                        </p>
                        </MDBCol>
                </MDBRow>
                <MDBRow>

               
                </MDBRow>
              </MDBModalBody>
          </MDBModal>
          
        </MDBContainer>
    )
}

export default InfoBox
